import Button from 'app/components/Button';
import EmailIcon from 'app/components/Icons/EmailIcon';
import Input from 'app/components/Input';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import rightArrow from '../../../../assets/svgs/ic_right_arrow_primary.svg';
import TitleText from '../components/TitleText';
import { validateForgotPasswordForm } from '../helpers';
import { selectForgotPasswordForm } from '../redux/selector';
import { actions } from '../redux/slice';

export default function ForgotPassword() {
    const forgotPasswordForm = useSelector(selectForgotPasswordForm);
    const emailInputRef = useRef<HTMLInputElement>(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const errors = validateForgotPasswordForm({
            email: {
                value: emailInputRef.current?.value || "",
                error: ""
            }
        });
        if (errors.length > 0) {
            dispatch(actions.setForgotPasswordFormErrors(errors));
            return;
        }
        dispatch(actions.forgotPasswordRequest({
            email: emailInputRef.current?.value || "", callback: () => {
            dispatch(actions.clearForgotPasswordForm())
            navigate("/auth/recovery-success");
        }}));
    }
    return (
        <div className='flex flex-col items-center'>
             <TitleText title="Forgot your password?" />
            <form className='flex flex-col gap-[20px] w-full max-w-[390px] mb-[56px]' onSubmit={handleSubmit}>
                <Input 
                    id="email" 
                    label="Email" 
                    type="email" 
                    placeholder="Enter email address" 
                    icon={<EmailIcon />}
                    defaultValue={forgotPasswordForm.email.value}
                    error={forgotPasswordForm.email.error}
                    disabled={forgotPasswordForm.isLoading}
                    inputRef={emailInputRef}
                    onChange={(e) => {
                        dispatch(actions.resetForgotPasswordFormError());
                    }}
                />
                <div className="flex items-center justify-between">
                        <Button 
                            className='w-full h-[56px] mt-2'
                            disabled={forgotPasswordForm.isLoading || !!forgotPasswordForm.email.error}
                            isLoading={forgotPasswordForm.isLoading}
                        >
                            Send me link
                        </Button>
                </div>
            </form>
            <div className='flex flex-col items-center gap-[16px]'>
                <p className='text-secondary text-md leading-[24px] flex flex-row items-center gap-[6px]'>or <Link to="/auth/login" className="text-primary text-md leading-[24px] font-medium flex flex-row items-center">Log in <img sizes='16px' src={rightArrow} alt="Arrow" /></Link></p>
            </div>
        </div>
    )
}
